<!-- 回调页面 -->
<template>
  <div class="panel">
    <div class="box">
      <div class="top">
        <div class="box-left">
          <img src="@public/img/icon_note.png" alt="" />
          <div class="box-left-l">
            <div>支付失败！</div>
            <div>
              进入<span>我的订单</span> 查看订单详情，继续支付或关闭订单。
            </div>
          </div>
        </div>
        <div class="box-right">
          <img src="@public/img/message.png" alt="" style="width: 65px;" />
          <div class="box-right-r">
            <div>国内短信包</div>
            <div>国内短信包</div>
            <div>国内短信包</div>
            <el-button size="small" class="margin20" type="primary" plain
              >重新支付</el-button
            >
          </div>
        </div>
      </div>
      <div></div>
      <div class="bottom">
        <h4>支付宝已扣款，但仍显示支付失败？</h4>
        <h5>
          这可能是网络传输发生故障或延时造成的，请稍候在<a
            href="/my/order_list.html?spid=100000821072"
            >我的订单</a
          >查看订单状态。
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {}
};
</script>
<style lang="scss" scoped>
.margin20 {
  margin: 20px 0;
}
.panel {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  background: #f2f2f6;
  .box {
    border-radius: 6px;
    padding: 144px 100px;
    background: #fff;
    .top {
      // height: 90px;
      display: flex;
      align-items: flex-start;
      img {
        margin-right: 20px;
      }
      .box-left {
        display: flex;
        width: 50%;

        .box-left-l {
          > div {
            height: 50%;
            padding-top: 5px;
          }
        }
      }
      .box-right {
        display: flex;
        align-items: flex-start;
        > div {
          padding-top: 5px;
          font-size: 14px;
        }
      }
    }
    .bottom {
      width: 100%;
      background: 0 0;
      text-align: center;
      font-size: 16px;
      color: #595961;
      h4 {
        margin: 20px 0;
      }
    }
  }
}
</style>
